module.exports = "/static/assets/5fe28c3aac7eff532b531b1f40884a5b.png";